export const getTableRowNode = () => {
  return {
    content: '(table_cell | table_header)*',
    tableRole: 'row',
    parseDOM: [{
      tag: 'tr'
    }],
    toDOM() {
      return ['tr', 0];
    }
  };
};